module.exports = __webpack_public_path__ + "img/1PC.d41eca6f.png";